const actions = {
  // Action Types for Donor Personal Details Creation
  DONOR_PERSONAL_DETAILS_CREATE_REQUEST:
    "DONOR_PERSONAL_DETAILS_CREATE_REQUEST",
  DONOR_PERSONAL_DETAILS_CREATE_SUCCESS:
    "DONOR_PERSONAL_DETAILS_CREATE_SUCCESS",
  DONOR_PERSONAL_DETAILS_CREATE_ERROR: "DONOR_PERSONAL_DETAILS_CREATE_ERROR",

  //donor update
  DONOR_DETAILS_UPDATE_REQUEST: "DONOR_DETAILS_UPDATE_REQUEST",
  DONOR_DETAILS_UPDATE_SUCCESS: "DONOR_DETAILS_UPDATE_SUCCESS",
  DONOR_DETAILS_UPDATE_ERROR: "DONOR_DETAILS_UPDATE_ERROR",

  // donation details create
  DONATION_DETAILS_CREATE_REQUEST: "DONATION_DETAILS_CREATE_REQUEST",
  DONATION_DETAILS_CREATE_SUCCESS: "DONATION_DETAILS_CREATE_SUCCESS",
  DONATION_DETAILS_CREATE_ERROR: "DONATION_DETAILS_CREATE_ERROR",

  SEND_MAIL_REQUEST: "SEND_MAIL_REQUEST",
  SEND_MAIL_REQUEST_SUCCESS: "SEND_MAIL_REQUEST_SUCCESS",
  SEND_MAIL_REQUEST_ERROR: "SEND_MAIL_REQUEST_ERROR",

  

  RESET_ACTIONTYPE: "RESET_ACTIONTYPE",

  // Action Creators for Creating Donor Personal Details
  createDonorPersonalDetails: (url, body) => ({
    type: actions.DONOR_PERSONAL_DETAILS_CREATE_REQUEST,
    payload: { url, body }, // Assuming donorId and other details are needed to create personal details
  }),

  updateDonorDetails: (url, body) => ({
    type: actions.DONOR_DETAILS_UPDATE_REQUEST,
    payload: { url, body }, // Assuming donorId and other details are needed to create personal details
  }),

  createDonationDetails: (url, body) => ({
    type: actions.DONATION_DETAILS_CREATE_REQUEST,
    payload: { url, body },
  }),

  sendmail:(url, body) => ({
    type: actions.SEND_MAIL_REQUEST,
    payload: { url, body },
  }),

  // Reset Action for Donor Personal Details
  resetDonorPersonalDetails: () => ({
    type: actions.RESET_ACTIONTYPE,
  }),
};

export default actions;
